window.UneekSso = {
  url: window.location.origin || "",
  UserSessions: {
    modalSelector: null,
    getTabsSelector: function () {
      return ".user-sessions-form .modal-header .nav-link";
    }
  }
};
